import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Footer.css';

function Footer() {

    const location = useLocation();

    const isMenuPage = location.pathname === '/menu';
    const isContactPage = location.pathname === '/kontakt';
    const isAboutPage = location.pathname === '/o-nas';
    const isGalleryPage = location.pathname === '/galeria';
    const isPolicyPage = location.pathname === '/polityka';
    const isHomePage = location.pathname === '/';

    if (isHomePage || isContactPage || isAboutPage || isGalleryPage || isPolicyPage || isMenuPage) {
        
        return (
            <footer className="footer text-white py-5">
            <div className='container'>
                <div className='row'>
                    <div className='col-md-4 mb-4 mb-md-0'>
                        <img src={require('../assets/icons/logo.png')} alt="logo" className="logo" />
                        <hr className='divider' style={{width: '70%'}} />
                        <p>
  <a href="https://www.facebook.com/restauracjasamiswoi/?locale=pl_PL" 
     className="text-light text-decoration-none d-flex align-items-center">
    <svg fill='white' className="social-icon" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m437 0h-362c-41.351562 0-75 33.648438-75 75v362c0 41.351562 33.648438 75 75 75h151v-181h-60v-90h60v-61c0-49.628906 40.371094-90 90-90h91v90h-91v61h91l-15 90h-76v181h121c41.351562 0 75-33.648438 75-75v-362c0-41.351562-33.648438-75-75-75zm0 0"/></svg>
    <span>Restauracja SAMI SWOI</span>
  </a>
</p>
<p>
  <a href="https://www.instagram.com/restauracjasamiswoi/" 
     className="text-light text-decoration-none d-flex align-items-center">
    <svg fill='white' className="social-icon bi bi-instagram" viewBox="0 0 16 16"><path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/></svg>
    <span>restauracjasamiswoi</span>
  </a>
</p>
                        <p className='text-light'>&copy; 2025 Sami Swoi</p>
                    </div>
                    <div className='col-md-3 mb-4 mb-md-0'>
                        <h5 className='footer-title'>Adres</h5>
                        <hr className='divider' />
                        <p className='text-light'>Sami Swoi</p>
                        <p className='text-light'>ul. Włókniarzy 1A,</p>
                        <p className='text-light'>34-120 Andrychów</p>
                        <p className='text-light'>NIP: 551-167-84-73</p>
                    </div>
                    <div className='col-md-3 mb-4 mb-md-0'>
                        <h5 className='footer-title'>Kontakt</h5>
                        <hr className='divider' />
                        <p>
                            <a href='tel:+48795596427' className='text-light text-decoration-none'>+48 795 596 427</a>
                        </p>
                        <p>
                            <a href='mailto:samiswoi@onet.eu' className='text-light text-decoration-none'>samiswoi@onet.eu</a>
                        </p>
                        <p>
                            <a href='https://www.facebook.com/restauracjasamiswoi/?locale=pl_PL' className='text-light text-decoration-none'>Facebook</a>
                        </p>
                    </div>
                    <div className='col-md-2 mb-4 mb-md-0'>
                        <h5 className='footer-title'>Więcej</h5>
                        <hr className='divider' />
                        <p>
                            <Link to='/' className='text-light text-decoration-none'>Strona główna</Link>
                        </p>
                        <p>
                            <Link to='/menu' className='text-light text-decoration-none'>Menu</Link>
                        </p>
                        <p>
                            <Link to='/galeria' className='text-light text-decoration-none'>Galeria</Link>
                        </p>
                        <p>
                            <Link to='/o-nas' className='text-light text-decoration-none'>O nas</Link>
                        </p>
                        <p>
                            <Link to='/kontakt' className='text-light text-decoration-none'>Kontakt</Link>
                        </p>
                    </div>
                </div>
            </div>
        </footer>
        )

    } else {
        return null;
    }

}

export default Footer;